"use strict";
var wellKnownSymbol = require("../internals/well-known-symbol");
var MATCH = wellKnownSymbol("match");
module.exports = function(METHOD_NAME) {
  var regexp = /./;
  try {
    "/./"[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return "/./"[METHOD_NAME](regexp);
    } catch (error2) {
    }
  }
  return false;
};
